import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Table,
  Badge,
  Button
} from 'reactstrap';

const StaffRequestItemsOffcanvas = ({ isOpen, toggle, requestData, onCreateTO }) => {
  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      style={{ width: '600px' }}
    >
      <OffcanvasHeader toggle={toggle}>
        Requested Items - {requestData?.staff_name} ({requestData?.staff_id})
      </OffcanvasHeader>
      <OffcanvasBody>
        <div className="table-responsive">
          <Table bordered>
            <thead className="table-light">
              <tr>
                <th>SKU</th>
                <th>Item Title</th>
                <th className="text-center">Requested Qty</th>
              </tr>
            </thead>
            <tbody>
              {requestData?.items?.map((item, index) => (
                <tr key={index}>
                  <td className="fw-bold">{item.sku}</td>
                  <td>{item.title}</td>
                  <td className="text-center">
                    <Badge color="soft-primary" className="text-primary fs-6">
                      {item.requested_qty}
                    </Badge>
                  </td>
                </tr>
              ))}
              {(!requestData?.items || requestData.items.length === 0) && (
                <tr>
                  <td colSpan="3" className="text-center">No items found</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        {/* <div className="mt-4 d-grid">
          <Button
            color="success"
            onClick={() => onCreateTO(requestData)}
            disabled={!requestData?.items || requestData.items.length === 0}
          >
            <i className="fa fa-plus me-2"></i> Create Transfer Order (TO)
          </Button>
        </div> */}
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default StaffRequestItemsOffcanvas;
